var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcModuleLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-module") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Legend-Expanded",
    transform: "translate(-690.000000, -175.000000)",
    fill: "black"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(586.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schematic-View",
    transform: "translate(55.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tag-+-Active-Component",
    transform: "translate(39.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.212,10.881 L45.044,10.881 L45.044,8.439 C45.044,7.092 46.127,6 47.484,6 C48.832,6 49.925,7.101 49.925,8.439 L49.925,10.881 C52.885,10.881 54.806,12.801 54.806,15.762 L54.806,45.044 C54.806,48.005 52.885,49.925 49.925,49.925 L49.925,52.367 C49.925,53.714 48.842,54.806 47.484,54.806 C46.137,54.806 45.044,53.704 45.044,52.367 L45.044,49.925 L38.212,49.925 L38.212,52.367 C38.212,53.714 37.129,54.806 35.772,54.806 C34.424,54.806 33.331,53.704 33.331,52.367 L33.331,49.925 L27.475,49.925 L27.475,52.367 C27.475,53.714 26.392,54.806 25.034,54.806 C23.687,54.806 22.594,53.704 22.594,52.367 L22.594,49.925 L15.762,49.925 L15.762,52.367 C15.762,53.714 14.679,54.806 13.321,54.806 C11.974,54.806 10.881,53.704 10.881,52.367 L10.881,49.925 C7.921,49.925 6,48.005 6,45.044 L6,15.762 C6,12.801 7.921,10.881 10.881,10.881 L10.881,8.439 C10.881,7.092 11.964,6 13.321,6 C14.669,6 15.762,7.101 15.762,8.439 L15.762,10.881 L22.594,10.881 L22.594,8.439 C22.594,7.092 23.677,6 25.034,6 C26.382,6 27.475,7.101 27.475,8.439 L27.475,10.881 L33.331,10.881 L33.331,8.439 C33.331,7.092 34.414,6 35.772,6 C37.119,6 38.212,7.101 38.212,8.439 L38.212,10.881 Z",
    id: "Fill-4"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcModuleLight);
export default __webpack_public_path__ + "static/media/ic-module-light.b1f56dc4086b65f5f2c424d6cf5a5c52.svg";
export { ForwardRef as ReactComponent };